module.exports = __webpack_public_path__ + "static/img/chanta (20).5054420.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (20).jpg
// module id = 2FZ+
// module chunks = 0